module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/100dd29cd5c4078cae9f5c2f978c1be8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Silver/Silver3.svg
// module id = mEYJ
// module chunks = 1